"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Expose app version info client-side via the `appInfo` convention to assist
 * with testing and debugging.
 */
function setAppInfo(name, version) {
    // Bail if we're not in a browser environment. See PERF-802.
    if (typeof window === 'undefined')
        return;
    const win = window;
    const origAppInfo = win.appInfo || {};
    win.appInfo = Object.assign(Object.assign({}, origAppInfo), { [name]: version });
}
exports.default = setAppInfo;
